<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2022-12-01 19:06:35
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2024-04-22 14:45:30
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/components/product/productManage/productList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 商品销售规则 -->
<template>
  <div>
    <div class="container">
      <div class="title">
        <span>商品规格</span>
        <span>
          如无可用规格属性，可
          <i class="pointer" @click="applyAttrDialog">申请新增</i>
        </span>
      </div>
      <div class="info-content">
        <div class="tab-content">
          <div
            class="tab-btn"
            :class="{ active: isShowList }"
            @click="handleTab(1)"
          >
            新增商品
          </div>
          <div
            class="tab-btn"
            :class="{ active: !isShowList }"
            @click="handleTab(2)"
          >
            相同属性商品查看
          </div>
          <!-- <el-button-group style="width: 100%">
          <el-button class="tab-btn active"  type="default" @click="handleTab(1)">新增商品</el-button>
          <el-button class="tab-btn" type="default" @click="handleTab(2)"
            >相同属性商品查看
          </el-button>
          </el-button-group>-->
        </div>
        <div class="info-form">
          <e-search
            v-show="isShowList"
            :count="filterInfo.count"
            :data="filterInfo.data"
            :field-list="filterInfo.fieldList"
            :list-type-info="listTypeInfo"
            @handleFilter="handleFilter"
            @handleReset="handleReset"
          ></e-search>
          <e-search
            v-show="!isShowList"
            :count="filterInfoSame.count"
            :data="filterInfoSame.data"
            :field-list="filterInfoSame.fieldList"
            @handleFilter="handleFilterSame"
            @handleReset="handleResetSame"
          ></e-search>
        </div>
        <div class="info-table">
          <div v-show="isShowList" class="btn-content">
            <!-- <el-button @click="addOneProduct">单条新增</el-button>
          <el-button @click="openDialog(2)">批量新增</el-button>
            <el-button @click="openAddImgDialog">统一配图</el-button>-->
            <div class="btn-default other-btn" @click="addOneProduct">
              单条新增
            </div>
            <div class="btn-default other-btn" @click="openDialog(2)">
              批量新增
            </div>
            <div class="btn-default other-btn" @click="openAddImgDialog">
              统一配图
            </div>
            <div class="btn-default other-btn" @click.self="openSetDialog">
              批量设置
            </div>
            <div class="btn-default other-btn" @click="batchDelete">删除</div>
          </div>
          <product-table-list
            v-show="isShowList"
            ref="tableList"
            :loading="loading"
            :table-label="tableHeadList"
            :table-data="showTableDataList"
            :selection-show="true"
            :repeat-list="repeatList"
            @handleInput="showStandardDialog"
            @handleSelectionChange="handleSelectionChange"
            @handleButton="handleButton"
          >
            <!-- eslint-disable-next-line -->
            <template v-slot:id="slot">
              <span class="delete-btn" @click="deleteRow(slot.scope.$index)"
                >删除</span
              >
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:img="slot">
              <img
                v-if="
                  slot.scope.row.mainImgList != undefined &&
                  slot.scope.row.mainImgList.length > 0
                "
                class="img-in-table poniter"
                :src="slot.scope.row.img"
                alt
                @click.stop="
                  openAddImgDialogInTable(slot.scope.$index, slot.scope.row)
                "
              />
              <el-button
                v-else
                @click.stop="
                  openAddImgDialogInTable(slot.scope.$index, slot.scope.row)
                "
              >
                <i
                  class="el-icon-circle-plus-outline"
                  style="font-size: 20px; color: #666"
                ></i>
                <!-- 添加图片 -->
                <!-- <img style="width:30px" src="../../../../../assets/img/product/icon-add@2x.png" alt="添加图片" />  -->
              </el-button>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:skuName="slot">
              <el-input
                v-model="slot.scope.row.skuName"
                @blur="
                  handleChangeSkuName(
                    slot.scope.row.skuName,
                    'skuName',
                    slot.scope.row.id
                  )
                "
              ></el-input>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:skuStock="slot">
              <el-input
                v-model="slot.scope.row.skuStock"
                placeholder="请输入0-100万之间的正数，最多三位小数"
                @blur="
                  checkNumOneMillion(
                    slot.scope.row.skuStock,
                    'skuStock',
                    slot.scope.row.id
                  )
                "
                @input="
                  slot.scope.row.skuStock = slot.scope.row.skuStock.replace(
                    /[^0-9.]/g,
                    ''
                  )
                "
              ></el-input>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:minOrderQuantity="slot">
              <el-input
                v-model="slot.scope.row.minOrderQuantity"
                placeholder="请输入0-100万之间的正数，最多三位小数"
                @blur="
                  checkNumOneMillion(
                    slot.scope.row.minOrderQuantity,
                    'minOrderQuantity',
                    slot.scope.row.id
                  )
                "
                @input="
                  slot.scope.row.minOrderQuantity =
                    slot.scope.row.minOrderQuantity.replace(/[^0-9.]/g, '')
                "
              ></el-input>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:deliverTime="slot">
              <el-input
                v-model="slot.scope.row.deliverTime"
                placeholder="请输入0-365之间的正整数"
                @blur="
                  checkNumOneHundred(
                    slot.scope.row.deliverTime,
                    'deliverTime',
                    slot.scope.row.id
                  )
                "
                @input="
                  slot.scope.row.deliverTime =
                    slot.scope.row.deliverTime.replace(/[^0-9.]/g, '')
                "
              ></el-input>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:price="slot">
              <el-input
                v-model="slot.scope.row.price"
                placeholder="请输入0-10亿之间的正数，最多2位小数"
                @blur="
                  checkNumOnebillion(
                    slot.scope.row.price,
                    'price',
                    slot.scope.row.id
                  )
                "
                @input="
                  slot.scope.row.price = slot.scope.row.price.replace(
                    /[^0-9.]/g,
                    ''
                  )
                "
              ></el-input>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:isConfirm="slot">
              <div>
                <el-select
                  v-model="slot.scope.row.isConfirm"
                  placeholder="请选择"
                  @change="
                    (val) => {
                      tableConfirmHandle(
                        val,
                        slot.scope.$index,
                        slot.scope.row.id
                      );
                    }
                  "
                >
                  <el-option
                    v-for="item in [
                      { label: '是', value: 1 },
                      { label: '否', value: 0 },
                    ]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </template>
            <!-- eslint-disable-next-line -->
            <!-- 交货期 -->
            <template #deliveryType="slot">
              <div>
                <el-select
                  v-model="slot.scope.row.deliveryType"
                  placeholder="请选择"
                  @change="
                    (val) => {
                      tableDeliveryTypeHandle(
                        val,
                        slot.scope.$index,
                        slot.scope.row.id
                      );
                    }
                  "
                >
                  <el-option
                    v-for="item in [
                      { label: '现货', value: 1 },
                      { label: '期货', value: 2 },
                    ]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </template>
            <!-- eslint-disable-next-line -->
            <!-- 单位列表 -->
            <template #unitVal="slot">
              <div>
                <el-select
                  v-model="slot.scope.row.unitVal.unitValue"
                  placeholder="请选择"
                  @change="
                    (val) => {
                      tableUnitHandle(
                        val,
                        slot.scope.$index,
                        slot.scope.row.id
                      );
                    }
                  "
                >
                  <!-- <el-option label="请选择" value=""> </el-option> -->
                  <el-option
                    v-for="item in unitListTable"
                    :key="item.unitId"
                    :label="item.unitName"
                    :value="item.unitName"
                  ></el-option>
                </el-select>
              </div>
            </template>
          </product-table-list>
          <!-- <product-add
            :tableData="
              tableDataList.slice(
                (productTagPage.currentPage - 1) * productTagPage.pageSize,
                productTagPage.currentPage * productTagPage.pageSize
              )
            "
            :tableHeadData="tableHeadList"
            :dialogVisible="dialogVisible"
            v-show="isShowList"
            @updateTableData="updateTableData"
            @openImgDialog="openImgDialog"
          ></product-add>-->
          <product-list
            v-show="!isShowList"
            :table-data="sameAttrTableData.records"
          ></product-list>
        </div>
        <div class="page-wrap">
          <el-pagination
            v-show="isShowList"
            :current-page="productTagPage.currentPage"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="productTagPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableDataList.length"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
          <el-pagination
            v-show="!isShowList"
            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="productTagPageSame.pageNum"
            :page-size="productTagPageSame.pageSize"
            :total="sameAttrTableData.total"
            @size-change="handleSizeChangeSame"
            @current-change="handleCurrentChangeSame"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 批量新增 -->
      <batchAddProduct
        :drawer-visible="drawerVisible"
        :width-size="840"
        @handleDrawerSubmit="unitSubmitPopupData"
        @handleDrawerCancel="unitUpdateVisible"
      >
        <div class="drawer-wrap">
          <div class="table-head-wrap">
            <div class="table-head-1">规格名称</div>
            <div class="table-head-2">
              值
              <el-input
                v-model="searchAttrValue"
                style="width: 180px"
                placeholder="请输入查询数据,按回车搜索"
                suffix-icon="el-icon-search"
                @keyup.enter.native="handleSearchAttrValue"
              >
              </el-input>
            </div>
            <div class="table-head-1">计量单位值</div>
          </div>
          <div class="table-body-wrap">
            <div class="table-body-left">
              <div
                v-for="(item, index) in formatTableData"
                :key="item.attributeId"
                class="table-body-1 attribute-name"
                :class="[currentAttributeIndex === index ? 'isActive' : '']"
                @click="handleChoiceAttribute(index, item.attributeId)"
              >
                {{ item.attributeName }}
              </div>
            </div>
            <div class="table-body-center">
              <div
                v-for="(item, index) in formatTableData"
                v-if="currentAttributeIndex === index"
                :key="item.attributeId"
                class="table-body-2"
              >
                <el-checkbox-group
                  v-if="
                    item.attributeValueListPage !== undefined &&
                    item.attributeValueListPage.records.length > 0
                  "
                  v-model="checkList[index]"
                  class="attr-group"
                >
                  <el-checkbox
                    v-for="subItem in item.attributeValueListPage.records"
                    :key="subItem.attributeValueId + index"
                    :label="subItem.attributeValue"
                    @change="
                      selectVale(
                        subItem.attributeValue,
                        subItem.attributeValueId,
                        index,
                        'value',
                        item.attributeName,
                        item.attributeId,
                        item.beforeSymbol,
                        item.behindSymbol,
                        item.connectSymbol
                      )
                    "
                  >
                    {{ subItem.attributeValue }}
                    <img
                      v-show="!subItem.attributeValueId"
                      class="icon-delete"
                      src="../../../../../assets/img/product/icon-delete@2x.png"
                      alt
                      @click.stop="
                        deleteAttr(
                          item,
                          subItem.attributeValue,
                          index,
                          subItem.attributeValueId
                        )
                      "
                    />
                  </el-checkbox>
                </el-checkbox-group>
                <el-input
                  v-if="item.customFlag == 1"
                  v-model.trim="attrValueList[index].val"
                  class="attr-input"
                  style="width: 100px; margin-right: 10px; margin-left: 10px"
                  placeholder="请输入内容"
                ></el-input>
                <div class="add-attr-btn-wrap">
                  <!-- <i class="el-icon-plus"></i> -->
                  <eui-btn
                    v-if="item.customFlag == 1"
                    type="text"
                    @click="addAttr(item, index)"
                    >添加</eui-btn
                  >
                  <eui-btn
                    v-if="
                      item.attributeValueListPage &&
                      item.attributeValueListPage.size <
                        item.attributeValueListPage.total
                    "
                    type="text"
                    @click="showMoreAttr(item.attributeId, index)"
                    >加载更多</eui-btn
                  >
                </div>
              </div>
            </div>
            <div class="table-body-right">
              <div
                v-for="(item, index) in formatTableData"
                v-if="currentAttributeIndex === index"
                :key="item.attributeId"
                class="table-body-1"
              >
                <el-checkbox-group v-model="unitCheckList[index]">
                  <el-checkbox
                    v-for="subItem in item.unitList"
                    :key="subItem.unitId"
                    :label="subItem.unitId"
                    @change="
                      selectVale(
                        subItem.unitName,
                        subItem.unitId,
                        index,
                        'unit',
                        item.attributeName,
                        item.attributeId,
                        item.beforeSymbol,
                        item.behindSymbol,
                        item.connectSymbol
                      )
                    "
                    >{{ subItem.unitName }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <div class="select-title">已选择</div>
          <div class="select-attr-wrap">
            <div
              v-for="(attrItem, index) in showSelectAttrAndUnitList"
              :key="attrItem.attributeId"
              class="table-row"
            >
              <div
                class="table-col-1"
                :style="{
                  'border-bottom':
                    index === showSelectAttrAndUnitList.length - 1
                      ? '1px solid #dcdcdc'
                      : '',
                }"
              >
                <div class="value-title">{{ attrItem.attributeName }}-值</div>
                <div class="value-wrap">
                  <div
                    v-for="subAttrItem in attrItem.selectedAttributeValueList"
                    :key="subAttrItem.attributeValueId"
                    class="value-item"
                  >
                    {{ subAttrItem.attributeValue }}
                    <span
                      @click="
                        handleDelectAttrAndUnit(
                          subAttrItem.attributeValue,
                          subAttrItem.attributeValueId,
                          index,
                          'value',
                          attrItem.attributeName,
                          attrItem.attributeId,
                          attrItem.beforeSymbol,
                          attrItem.behindSymbol,
                          attrItem.connectSymbol
                        )
                      "
                    >
                      <eui-icon icon="eicon-close" font-size="12px"></eui-icon>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="table-col-2"
                :style="{
                  'border-bottom':
                    index === showSelectAttrAndUnitList.length - 1
                      ? '1px solid #dcdcdc'
                      : '',
                }"
              >
                <div class="value-title">
                  {{ attrItem.attributeName }}-计量单位
                </div>
                <div class="value-wrap">
                  <div
                    v-for="subunititem in attrItem.selectedUnitList"
                    class="value-item"
                  >
                    {{ subunititem.unitName }}
                    <span
                      @click="
                        handleDelectAttrAndUnit(
                          subunititem.unitName,
                          subunititem.unitId,
                          index,
                          'unit',
                          attrItem.attributeName,
                          attrItem.attributeId,
                          attrItem.beforeSymbol,
                          attrItem.behindSymbol,
                          attrItem.connectSymbol
                        )
                      "
                    >
                      <eui-icon icon="eicon-close" font-size="12px"></eui-icon>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </batchAddProduct>
      <applyDialog
        dialog-title="规格属性申请"
        :center-dialog-visible="applyAttrVisible"
        :popup-width="'800px'"
        :show-tip="true"
        @resetPopupData="applyAttrUpdateVisible"
        @submitPopupData="attributeSubmitPopupData"
      >
        <el-form ref="ruleForm" :model="attrForm" :rules="rules">
          <el-form-item
            label="规格属性名称"
            :label-width="formLabelWidth"
            prop="attributeName"
          >
            <el-input
              v-model.trim="attrForm.attributeName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item
            v-for="(attrStr, index) in attrForm.attrStr"
            :label="'规格值'"
            :key="attrStr.key"
            :prop="'attrStr.' + index + '.value'"
            :label-width="formLabelWidth"
            :rules="{
              required: true,
              message: '规格值不能为空',
              trigger: 'blur',
            }"
          >-->
          <el-form-item
            :label="'规格值'"
            prop="attrStr"
            :label-width="formLabelWidth"
          >
            <div style="display: flex; flex-wrap: wrap">
              <span
                v-for="(attrStr, index) in attrForm.attrStr"
                :key="index"
                class="attr-wrap"
              >
                {{ attrStr }}
                <i
                  class="el-icon-close pointer"
                  @click.prevent="removeAttrStr(attrStr)"
                ></i>
              </span>
              <el-input
                v-model.trim="attrStrValue"
                placeholder="最多可输入20个字"
                autocomplete="off"
                style="width: 120px"
              ></el-input>
              <!-- <el-button v-if="index != 0" @click.prevent="removeAttrStr(attrStr)">删除</el-button> -->
              <el-button style="margin-left: 10px" @click="addAttrValue"
                >+</el-button
              >
            </div>
          </el-form-item>

          <el-form-item label="计量单位" :label-width="formLabelWidth">
            <el-select
              v-model="attrForm.attributeUnit"
              placeholder="请选择计量单位"
            >
              <el-option
                v-for="item in unitList"
                :key="item.unitid"
                :label="item.unitName"
                :value="item.unitName"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </applyDialog>
      <!-- 批量设置 -->
      <setDialog
        v-if="isShowSetDialog"
        :unit-list-table="unitListTable"
        @setSubmitPopupData="handleBatchSet"
        @setUpdateVisible="handleBatchSetUpdate"
      ></setDialog>
      <!-- 添加计量单位 -->
      <setUnitDialog
        v-if="isShowSetUnitDialog"
        @setUnitSubmitPopupData="handleUnitSet"
        @setUnitUpdateVisible="handleBatchSetUnitUpdate"
      ></setUnitDialog>
    </div>
    <div class="btn-box">
      <!-- <div class="btn-default" @click="goPre">上一步</div>
        <div class="btn-wrap">
            <div class="btn-save">保存</div>
            <div class="btn-audit" @click="submitTable">提交审核</div>
      </div>-->

      <el-button @click="goPre">上一步</el-button>
      <div class="btn-wrap">
        <!-- <el-button type="primary" @click="submitTable('save')">保存</el-button>
        <el-button type="primary" @click="submitTable('submit')"
          >提交审核</el-button
        >-->
        <d-button
          class="next-btn"
          type="primary"
          btn-txt="保存"
          @debounceclick="submitTable('save')"
        ></d-button>
        <d-button
          class="next-btn"
          type="primary"
          btn-txt="提交审核"
          @debounceclick="submitTable('submit')"
        ></d-button>
      </div>
    </div>
    <!-- 添加图片 -->
    <productAddImge
      ref="productAddImge"
      :dialog-visible="addImageDialogVisible"
      :detailFileList="detailFileList"
      :fileList="fileList"
      :imageUrlsExist="imageUrlsExist"
      :detailImageUrlsExist="detailImageUrlsExist"
      :mainImgList="mainImgList"
      :detailImgList="detailImgList"
      @handleAddImage="handleAddImage"
      @handleCancel="handleCancel"
    ></productAddImge>

    <!-- 行内选择规格值 -->
    <addAttrByTableLine
      ref="addAttrByTableLine"
      :attr-in-table-drawer-visible="attrInTableDrawerVisible"
      @handleDrawerCancel="handleAttrInTableDrawerCancel"
      @handleDrawerSubmitInTable="handleDrawerSubmitInTable"
    ></addAttrByTableLine>
  </div>
</template>

<script>
import batchAdd from '@/components/common/epecDialog';
import tableList from '@/components/common/table-list';
import applyDialog from '@/components/common/epecDialog';
import Bus from '@/components/common/bus.js';
import api from '../../../api/product/index.js';
import eSearch from '../../common/e-search';
// import productAdd from "./productAdd";
import util from '../../../utils/utils';
import setDialog from './productBatchSet.vue';
import setUnitDialog from './productUnitAdd.vue';
// import { mapMutations } from "vuex";
import productList from './productSameList';
import productUtils from '../../../utils/productUtils.js';
import productTableList from '../../../pages/product/createProducts/components/product-table-list.vue';
import batchAddProduct from './batchAddProduct.vue';
import addAttrByTableLine from './addAttrByTableLine.vue';
import productAddImge from './productAddImge.vue';

export default {
  components: {
    eSearch,
    // productAdd,
    batchAdd,
    tableList,
    applyDialog,
    productList,
    setDialog,
    productTableList,
    // Viewer,
    setUnitDialog,
    batchAddProduct,
    productAddImge,
    addAttrByTableLine,
  },
  data() {
    return {
      resolveFunc() {},

      attrStrValue: '', // 申请的属性值
      repeatList: [],
      isShowTable: false, //
      selectItemList: [], // 批量配图是选择的条数
      addImageDialogVisible: false,
      applyAttrVisible: false,
      loading: false,
      isShowList: true,
      tableData: [],
      sameAttrTableData: {}, // 相同属性
      unitVisible: false,
      attrForm: {
        attributeName: '',
        attrStr: [],
        attributeUnit: '',
      },
      rules: {
        attributeName: [
          { required: true, message: '请输入规格属性名称', trigger: 'blur' },
        ],
        attrStr: [
          { required: true, message: '请输入规格值', trigger: 'change' },
        ],
      },
      formLabelWidth: '120px',
      attrValue: '',
      attrValueList: [], // 存储自定义规格值
      filterInfo: {
        data: {
          // skuName: null,
        },
        fieldList: [{ label: '商品名称', type: 'input', value: 'skuName' }],
        /** 搜索/重置区域是否隐藏 */
        // btnHidden: true,
        /** 组件尺寸 */
        // size: 'small',
        /** 默认展示搜索条件 */
        count: 100,
        /** label/item 宽度 */
        // width: {
        //   labelWidth: 110,
        //   itemWidth: 220
        // },
        /** 配置项 */
        btnStyle: [
          { icon: 'el-icon-refresh', text: '重置' },
          { icon: 'el-icon-search', text: '查询', type: 'primary' },
        ],
      },
      filterInfoSame: {
        data: {
          // skuName: null,
        },
        fieldList: [
          { label: '商品名称', type: 'input', value: 'skuName' },
          { label: '规格', type: 'input', value: 'specificationStr' },
        ],
        /** 搜索/重置区域是否隐藏 */
        // btnHidden: true,
        /** 组件尺寸 */
        // size: 'small',
        /** 默认展示搜索条件 */
        count: 100,
        /** label/item 宽度 */
        // width: {
        //   labelWidth: 110,
        //   itemWidth: 220
        // },
        /** 配置项 */
        btnStyle: [
          { icon: 'el-icon-refresh', text: '重置' },
          { icon: 'el-icon-search', text: '查询', type: 'primary' },
        ],
      },
      listTypeInfo: {},
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
      },
      productTagPageSame: {
        pageNum: 1,
        pageSize: 10,
      },
      tableHeadList: [
        // { label: "操作", param: "id", align: "center", slot: "id" },
        {
          label: '商品图片',
          param: 'img',
          align: 'center',
          slot: 'img',
          fixed: true,
        },
        {
          label: '商品名称',
          param: 'skuName',
          align: 'center',
          slot: 'skuName',
          width: '300',
          fixed: true,
        },
        {
          label: '库存',
          param: 'skuStock',
          align: 'center',
          slot: 'skuStock',
          width: '200',
        },
        {
          label: '起订量',
          param: 'minOrderQuantity',
          align: 'center',
          slot: 'minOrderQuantity',
          width: '200',
        },
        {
          label: '订单是否确认',
          param: 'isConfirm',
          align: 'center',
          slot: 'isConfirm',
          width: '120',
          header: true,
        },
        {
          label: '交货期',
          param: 'deliveryType',
          align: 'center',
          slot: 'deliveryType',
          width: '120',
        },
        {
          label: '发货周期(天)',
          param: 'deliverTime',
          align: 'center',
          slot: 'deliverTime',
          width: '200',
        },
        {
          label: '计量单位',
          param: 'unitVal',
          align: 'center',
          slot: 'unitVal',
          width: '100',
          unit: true,
        },
        {
          label: '市场公开价(元)',
          param: 'price',
          align: 'center',
          slot: 'price',
          width: '200',
        },
        //  { label: "主图图库", param: "imageUrls", align: "center", },
        //  { label: "主图上传", param: "imageUrlsExist", align: "center",  },
        //  { label: "详情图库", param: "detailImageUrls", align: "center",  },
        //  { label: "详情上传", param: "detailImageUrlsExist", align: "center",},
      ],
      tableDataList: [],
      showTableDataList: [], // 展示的数据页
      attrStr: '', // 属性拼接串
      formatTableData: [],
      formatTableLabel: [
        {
          label: '规格',
          param: 'attributeName',
          align: 'center',
          width: '180',
        },
        {
          label: '值',
          param: 'attributeValueList',
          align: 'center',
          slot: 'value',
        },
        {
          label: '计量单位',
          param: 'unitList',
          align: 'center',
          slot: 'unit',
          width: '180',
        },
      ],
      temSelectList: [], // 暂存选中规格
      unitList: [],
      checkList: [],
      unitCheckList: [],
      isShowSetDialog: false, // 是否显示批量设置弹框
      isShowSetUnitDialog: false,
      isExistProductGroup: false, //

      // 商品列表数据集合
      currentIndex: 0, // 当前表格索引值
      currentStandardName: '',
      tableIndex: 0, // 商品列表的当前行
      tableId: null, // 商品列表当前行id
      standardRadioObj: {}, // 规格名字值
      unitRadioObj: {}, // 规格单位值
      unitListTable: [], // 单位列表
      standardList: [], // 规格列表
      selStandardObj: {
        attributeValueList: [],
        unitList: [],
      }, // 当前编辑的规格的对象数据

      formatVal: '',
      dialogImageUrl: '',
      mainImg: '商品主图管理',
      mainImgId: null, // 主图id
      fileList: [], // 主图文件列表
      detailFileList: [], // 详情图列表

      isMultImg: false, // 判断是否是统一配图
      multSelectList: [], // 多选行数据

      imgList: [], // 图片链接
      imageUrlsExist: [], // 图库主图文件
      detailImageUrlsExist: [], // 图库详情图文件
      showAddImg: false,
      mainImgList: [], // 主图回显列表
      detailImgList: [], // 详情图回显列表
      productId: '',
      selectedLeftTableIds: [], // 保存表格勾选的数据
      productInfo: {},
      canAdd: false,
      templateTableData: [], // 暂存表格数据
      searchVal: null,

      options: {
        inline: false,
        button: true,
        navbar: false,
        zoomable: false,
        rotatable: false,
        scalable: false,
        movable: false,
      },
      dragging: false,
      currentAttributeIndex: 0, // 批量新增当前选中行
      showSelectAttrAndUnitList: [],
      pageSize: 30, // 规格值当前展示数量
      searchAttrValue: null, // 规格值搜索
      attributeId: null,
      drawerVisible: false,
      checked: false,
      attrInTableDrawerVisible: false,
    };
  },

  computed: {},

  created() {
    this.initData();
    // this.getPropertyList();
    Bus.$on('subhandleSelectionChange', (val) => {
      console.log(val);
      this.selectItemList = val;
    });
  },
  activated() {
    console.log(this.$store.state.productList.attributeStr);
    console.log(this.productInfo.attributeStr);
    // debugger;
    const newCategory1 = this.$store.state.productList.attributeStr;
    const oldCategory1 = this.productInfo.attributeStr;
    const newCategory = this.$getStore('categoryNameStr');
    const oldCategory = this.productInfo.categoryName;
    if (newCategory != oldCategory || newCategory1 != oldCategory1) {
      this.showTableDataList = [];
      this.tableDataList = [];
      localStorage.removeItem('productTableList');
      this.attrValueList = [];
      this.unitCheckList = [];
      this.checkList = [];
      this.filterInfo.fieldList = [
        { label: '商品名称', type: 'input', value: 'skuName' },
      ];
      this.attrStr = '';
      (this.tableHeadList = [
        // { label: "操作", param: "id", align: "center", slot: "id" },
        { label: '图片', param: 'img', align: 'center', slot: 'img' },
        {
          label: '商品名称',
          param: 'skuName',
          align: 'center',
          slot: 'skuName',
          width: '260',
        },
        { label: '库存', param: 'skuStock', align: 'center', slot: 'skuStock' },
        {
          label: '起订量',
          param: 'minOrderQuantity',
          align: 'center',
          slot: 'minOrderQuantity',
        },
        {
          label: '订单是否确认',
          param: 'isConfirm',
          align: 'center',
          slot: 'isConfirm',
        },
        {
          label: '交货期',
          param: 'deliveryType',
          align: 'center',
          slot: 'deliveryType',
        },
        {
          label: '发货周期(天)',
          param: 'deliverTime',
          align: 'center',
          slot: 'deliverTime',
        },
        {
          label: '计量单位',
          param: 'unitVal',
          align: 'center',
          slot: 'unitVal',
        },
        {
          label: '市场公开价(元)',
          param: 'price',
          align: 'center',
          slot: 'price',
        },
      ]),
        this.initData();
    }
  },
  methods: {
    //  Bus.$emit('subhandleSelectionChange',val)
    handleButton(obj) {
      console.log(obj);
      if (obj.methods === 'addUnit') {
        this.isShowSetUnitDialog = true;
      }
    },

    // 新增商品列表内功能开始
    initData() {
      this.canAdd = false;
      this.loading = true;
      this.productInfo = JSON.parse(
        JSON.stringify(this.$store.state.productList)
      );
      this.getUnitInCategroy();
      this.getPropertyList(0, '');
      // this.getPropertyListInTable();
      this.isExistProductGroup = localStorage.getItem('isExistProductGroup');
      console.log(this.isExistProductGroup);
      // this.productId = localStorage.getItem("isExistProductGroupProductId");
      // if (this.productId != "null") {
      //   this.productTagPageSame.productId = this.productId;
      //   this.getSameAttrSkusByProducId(this.productTagPageSame);
      // }
    },
    // 获取规格列表
    async getPropertyListInTable() {
      const res = await api.getPropertyByCategory({
        categoryId: this.$store.state.productList.categoryId,
        attributeType: 2,
      });
      if (res.code == 200) {
        this.standardList = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    // 获取分类下的单位列表
    async getUnitInCategroy() {
      const param = {
        categoryId: this.$store.state.productList.categoryId,
      };
      const res = await api.getUnitByCategory(param);
      console.log(res);
      if (res.code == 200) {
        this.unitListTable = res.data;
        this.unitList = res.data;
      }
    },
    // 新增商品内的单位选择
    tableUnitHandle(val, index, id) {
      console.log(val);
      console.log(this.unitList);
      // console.log(id);
      const obj = util.getSelectLabel(this.unitList, val, 'unitName');
      console.log(obj);
      this.tableDataList[index].unitVal.unitValue = obj.unitName;
      const productTableList = JSON.parse(
        localStorage.getItem('productTableList')
      );
      for (let i = 0; i < productTableList.length; i++) {
        if (productTableList[i].id == id) {
          productTableList[i].unitVal.unitId = obj.unitId;
          productTableList[i].unitVal.unitValue = obj.unitName;
        }
      }
      localStorage.setItem(
        'productTableList',
        JSON.stringify(productTableList)
      );
      console.log(productTableList);
    },
    tableConfirmHandle(val, index, id) {
      const productTableList = JSON.parse(
        localStorage.getItem('productTableList')
      );
      for (let i = 0; i < productTableList.length; i++) {
        if (productTableList[i].id == id) {
          productTableList[i].isConfirm = val;
        }
      }
      localStorage.setItem(
        'productTableList',
        JSON.stringify(productTableList)
      );
    },
    tableDeliveryTypeHandle(val, index, id) {
      const productTableList = JSON.parse(
        localStorage.getItem('productTableList')
      );
      for (let i = 0; i < productTableList.length; i++) {
        if (productTableList[i].id == id) {
          productTableList[i].deliveryType = val;
        }
      }
      localStorage.setItem(
        'productTableList',
        JSON.stringify(productTableList)
      );
    },
    async openAddImgDialogInTable(index, row) {
      this.fileList = row.imageUrls ? row.imageUrls : [];
      this.detailFileList = row.detailImageUrls ? row.detailImageUrls : [];
      this.detailImageUrlsExist = row.detailImageUrlsExist
        ? row.detailImageUrlsExist
        : [];
      this.imageUrlsExist = row.imageUrlsExist ? row.imageUrlsExist : [];
      this.mainImgList = row.mainImgList ? row.mainImgList : [];
      this.detailImgList = row.detailImgList ? row.detailImgList : [];
      this.currentIndex = index;
      console.log(row);
      this.$nextTick(() => {
        this.$refs.productAddImge.initData();
      });

      this.isMultImg = false;
      this.addImageDialogVisible = true;
      console.log(this.mainImgList);
      console.log(this.detailImgList);
    },
    // 删除行项目
    deleteRow(index) {
      console.log(index);
      this.tableDataList.splice(index, 1);
      console.log(this.tableDataList);
    },
    // 提交图片
    handleAddImage(options) {
      // console.log(options);
      console.log('fileList', this.fileList);
      console.log('detailFileList', this.detailFileList);
      console.log('imageUrlsExist', this.imageUrlsExist);
      console.log('detailImageUrlsExist', this.detailImageUrlsExist);
      console.log('detailImgList', this.detailImgList);
      console.log('mainImgList', this.mainImgList);
      this.addImageDialogVisible = false;
      this.addImgInTable([
        this.fileList,
        this.detailFileList,
        this.imageUrlsExist,
        this.detailImageUrlsExist,
      ]);
    },
    //关闭添加图片弹框
    handleCancel() {
      this.fileList.length = 0;
      this.mainImgList.length = 0;
      this.detailFileList.length = 0;
      this.imageUrlsExist.length = 0;
      this.detailImageUrlsExist.length = 0;
      this.addImageDialogVisible = false;
    },
    // 关联图片插入表格数据
    addImgInTable(val) {
      console.log(val);
      let mainImgList = JSON.parse(JSON.stringify(this.mainImgList));
      if (this.isMultImg) {
        for (let j = 0; j < this.tableDataList.length; j++) {
          for (let i = 0; i < this.selectItemList.length; i++) {
            if (this.tableDataList[j].id == this.selectItemList[i].id) {
              this.tableDataList[j].imageUrls = JSON.parse(
                JSON.stringify(this.fileList)
              );
              this.tableDataList[j].detailImageUrls = JSON.parse(
                JSON.stringify(this.detailFileList)
              );
              this.tableDataList[j].imageUrlsExist = JSON.parse(
                JSON.stringify(this.imageUrlsExist)
              );
              this.tableDataList[j].detailImageUrlsExist = JSON.parse(
                JSON.stringify(this.detailImageUrlsExist)
              );
              this.tableDataList[j].mainImgList = JSON.parse(
                JSON.stringify(this.mainImgList)
              );
              this.tableDataList[j].detailImgList = JSON.parse(
                JSON.stringify(this.detailImgList)
              );
              this.$set(this.tableDataList[j], 'img', mainImgList[0].url);
              // this.tableDataList[j].img = mainImgList[0].url;
            }
          }
        }
        // 为localstorage中的添加图片
        const productTableList = JSON.parse(
          localStorage.getItem('productTableList')
        );
        for (let j = 0; j < productTableList.length; j++) {
          for (let i = 0; i < this.selectItemList.length; i++) {
            if (productTableList[j].id == this.selectItemList[i].id) {
              productTableList[j].imageUrls = JSON.parse(
                JSON.stringify(this.fileList)
              );
              productTableList[j].detailImageUrls = JSON.parse(
                JSON.stringify(this.detailFileList)
              );
              productTableList[j].imageUrlsExist = JSON.parse(
                JSON.stringify(this.imageUrlsExist)
              );
              productTableList[j].detailImageUrlsExist = JSON.parse(
                JSON.stringify(this.detailImageUrlsExist)
              );
              productTableList[j].mainImgList = JSON.parse(
                JSON.stringify(this.mainImgList)
              );
              productTableList[j].detailImgList = JSON.parse(
                JSON.stringify(this.detailImgList)
              );
              this.$set(productTableList[j], 'img', mainImgList[0].url);
              // productTableList[j].img = mainImgList[0].url;
            }
          }
        }
        console.log(this.tableDataList);
        localStorage.setItem(
          'productTableList',
          JSON.stringify(productTableList)
        );
      } else {
        this.tableDataList[this.currentIndex].imageUrls = JSON.parse(
          JSON.stringify(val[0])
        );
        this.tableDataList[this.currentIndex].detailImageUrls = JSON.parse(
          JSON.stringify(val[1])
        );
        this.tableDataList[this.currentIndex].imageUrlsExist = JSON.parse(
          JSON.stringify(val[2])
        );
        this.tableDataList[this.currentIndex].detailImageUrlsExist = JSON.parse(
          JSON.stringify(val[3])
        );
        this.tableDataList[this.currentIndex].mainImgList = this.mainImgList;
        this.tableDataList[this.currentIndex].detailImgList =
          this.detailImgList;
        this.tableDataList[this.currentIndex].img = this.mainImgList[0].url;
        console.log(this.tableDataList);
        // 为localstorage中的添加图片
        const productTableList = JSON.parse(
          localStorage.getItem('productTableList')
        );
        // debugger;
        console.log(productTableList);
        for (let j = 0; j < productTableList.length; j++) {
          if (
            productTableList[j].id === this.tableDataList[this.currentIndex].id
          ) {
            productTableList[j].imageUrls = JSON.parse(JSON.stringify(val[0]));
            productTableList[j].detailImageUrls = JSON.parse(
              JSON.stringify(val[1])
            );
            productTableList[j].imageUrlsExist = JSON.parse(
              JSON.stringify(val[2])
            );
            productTableList[j].detailImageUrlsExist = JSON.parse(
              JSON.stringify(val[3])
            );
            productTableList[j].mainImgList = this.mainImgList;
            productTableList[j].detailImgList = this.detailImgList;
            productTableList[j].img = this.mainImgList[0].url;
          }
        }
        localStorage.setItem(
          'productTableList',
          JSON.stringify(productTableList)
        );
      }

      this.mainImgList = [];
      this.detailImgList = [];
      this.fileList = []; // 主图文件列表
      this.detailFileList = []; // 详情图列表
      this.detailImageUrlsExist = [];
      this.imageUrlsExist = [];
      this.imgList = [];
    },
    // 增加自定义规格值
    addFormatVal() {
      console.log(util.deleteSpace(this.formatVal));
      if (util.deleteSpace(this.formatVal) == '') {
        this.$message.warning('规格值不能为空！');
        return;
      }
      if (
        util.getArgumentIndexInAttr(
          this.selStandardObj.attributeValueList,
          'attributeValue',
          this.formatVal
        ) == -1
      ) {
        if (util.deleteSpace(this.formatVal).length > 20) {
          this.$message.warning('规格值不能超过20个字');
          return;
        }
        this.selStandardObj.attributeValueList.push({
          attributeValue: this.formatVal,
          attributeValueId: '',
          //  checked: false
        });
        // 副本操作
        let copySelStandardObj = localStorage.getItem('selStandardObj');
        copySelStandardObj = JSON.parse(copySelStandardObj);
        copySelStandardObj.attributeValueList.push({
          attributeValue: this.formatVal,
          attributeValueId: '',
          //  checked: false
        });
        localStorage.setItem(
          'selStandardObj',
          JSON.stringify(copySelStandardObj)
        );
      } else {
        this.$message.warning('规格值不能重复');
      }

      // this.selStandardObj.attributeValueList.push({attributeValue: this.formatVal });
      this.formatVal = '';
    },

    handelSearchVal(val) {
      // let arr = this.selStandardObj.attributeValueList;
      let arr = JSON.parse(localStorage.getItem('selStandardObj'));
      //  console.log(arr);
      arr = arr.attributeValueList;
      const newArr = arr.filter(
        (item) => item.attributeValue.indexOf(val) != -1
      );
      // console.log(newArr);
      this.$set(this.selStandardObj, 'attributeValueList', newArr);
      if (!val) {
        this.selStandardObj = JSON.parse(
          localStorage.getItem('selStandardObj')
        );
      }
    },

    handleAttrInTableDrawerCancel() {
      this.$refs.addAttrByTableLine.handleDrawerClear();
      this.attrInTableDrawerVisible = false;
    },
    // 弹出规格弹框
    async showStandardDialog(val) {
      console.log(val);
      this.attrInTableDrawerVisible = !this.attrInTableDrawerVisible;
      this.$refs.addAttrByTableLine.initData(val);

      // this.searchVal = null;
      // this.standardVal = '';
      // this.unitVal = '';
      // this.unitRadioObj = {};
      this.tableIndex = val.index;
      this.tableId = val.id;
      // this.currentStandardName = val.standardName; //当前规格名字
      // this.addVisible = !this.addVisible;
      // let res = await api.getPropertyByCategory({
      //   categoryId: this.$store.state.productList.categoryId,
      //   attributeType: 2
      // });
      // if (res.code == 200) {
      //   let standardList = res.data;
      //   for (let i = 0; i < standardList.length; i++) {
      //     if (standardList[i].attributeId == val.val) {
      //       this.selStandardObj = standardList[i];
      //       break;
      //     }
      //   }
      //   console.log(this.selStandardObj);
      //   if (this.selStandardObj.attributeName == undefined) {
      //     this.$message.warning(
      //       '您发布的商品中有停用的属性，请刷新界面，重新发布'
      //     );
      //   }
      //   localStorage.setItem(
      //     'selStandardObj',
      //     JSON.stringify(this.selStandardObj)
      //   );
      //   this.attrLoading = false;
      // } else {
      //   this.$message.error(res.message);
      //   return;
      // }
    },

    handleDrawerSubmitInTable(options) {
      console.log(options);
      this.standardRadioObj = JSON.parse(
        JSON.stringify(options.standardRadioObj)
      );
      this.unitRadioObj = JSON.parse(JSON.stringify(options.unitRadioObj));
      this.selStandardObj = JSON.parse(JSON.stringify(options.selStandardObj));
      this.updateTableData({
        tableIndex: this.tableIndex,
        selStandardObj: this.selStandardObj,
        standardRadioObj: this.standardRadioObj,
        unitRadioObj: this.unitRadioObj,
        tableId: this.tableId,
      });
      this.attrInTableDrawerVisible = !this.attrInTableDrawerVisible;
      this.attrLoading = true;
      this.$refs.addAttrByTableLine.handleDrawerClear();
    },
    // 新增商品列表内功能结束

    handleSizeChange(val) {
      this.productTagPage.pageSize = val;
      this.showTableDataList = this.tableDataList.slice(
        (this.productTagPage.currentPage - 1) * this.productTagPage.pageSize,
        this.productTagPage.currentPage * this.productTagPage.pageSize
      );
    },
    handleCurrentChange(val) {
      console.log(val);
      this.productTagPage.currentPage = val;
      this.showTableDataList = this.tableDataList.slice(
        (this.productTagPage.currentPage - 1) * this.productTagPage.pageSize,
        this.productTagPage.currentPage * this.productTagPage.pageSize
      );
      // this.$refs.tableList.toggleRowSelection();
    },
    handleSizeChangeSame(val) {
      this.productTagPageSame.pageSize = val;
      this.getSameAttrSkusByProducId(this.productTagPageSame);
    },
    handleCurrentChangeSame(val) {
      this.productTagPageSame.pageNum = val;
      this.getSameAttrSkusByProducId(this.productTagPageSame);
    },
    handleFilter(val) {
      console.log(val);
      this.tableDataList = JSON.parse(localStorage.getItem('productTableList'));
      let arr = [];
      for (const key in val) {
        console.log(key);
        this.tableDataList.map((item) => {
          if (key == 'skuName' && val[key] != null) {
            if (item[key].indexOf(val[key]) != -1) {
              arr.push(item);
            }
          } else {
            const str = item[key].attributeValue + item[key].unitValue;
            if (str.indexOf(val[key]) != -1) {
              arr.push(item);
            }
          }
        });
        console.log(arr);
        this.tableDataList = arr;
        arr = [];
      }
      // this.tableDataList = arr;
      this.productTagPage.currentPage = 1;
      this.showTableDataList = this.tableDataList.slice(
        (this.productTagPage.currentPage - 1) * this.productTagPage.pageSize,
        this.productTagPage.currentPage * this.productTagPage.pageSize
      );
    },

    handleReset() {
      this.tableDataList = JSON.parse(localStorage.getItem('productTableList'));
      this.showTableDataList = this.tableDataList.slice(
        (this.productTagPage.currentPage - 1) * this.productTagPage.pageSize,
        this.productTagPage.currentPage * this.productTagPage.pageSize
      );
    },
    handleFilterSame(val) {
      console.log(val);
      this.productTagPageSame.skuName = val.skuName;
      this.productTagPageSame.specificationStr = val.specificationStr;
      this.productTagPageSame.pageNum = 1;
      this.getSameAttrSkusByProducId(this.productTagPageSame);
    },
    handleResetSame() {
      this.productTagPageSame.skuName = '';
      this.productTagPageSame.specificationStr = '';
      this.productTagPageSame.pageNum = 1;
      this.getSameAttrSkusByProducId(this.productTagPageSame);
    },
    unitUpdateVisible() {
      // this.unitVisible = !this.unitVisible;
      this.drawerVisible = !this.drawerVisible;
    },
    openImgDialog() {
      this.dialogVisible = !this.dialogVisible;
    },
    handleSelectionChange(options) {
      console.log(options);
      this.selectItemList = options;
    },
    handleSelectSingleTableAll(options) {
      console.log(options);
      // 获取当前页码所显示的数据
      const a = this.tableDataList.slice(
        (this.productTagPage.currentPage - 1) * this.productTagPage.pageSize,
        this.productTagPage.currentPage * this.productTagPage.pageSize
      );
      // 获取当前页勾选的数据
      const b = options;
      // 判断是取消全选还是全选
      const isLeftTableAllSelectStatus = b.every((val) => a.includes(val));
      // 如果表格总数据长度大于当前pageSize（说明此时页面表格数据超过了1页）
      // 如果小于一页，说明不需要多费心思用代码去实现勾选了
      if (this.tableDataList.length > this.productTagPage.pageSize) {
        if (isLeftTableAllSelectStatus == true) {
          // 从非全选状态切换成了全选状态
          this.againDrawTableTick(true);
        } else {
          // 从全选状态切换成了非全选状态
          this.againDrawTableTick(false);
        }
      }
    },
    // 重新绘制表格勾选状态
    againDrawTableTick(flag) {
      // 重新渲染勾选
      if (
        !this.selectedLeftTableIds.length ||
        !this.selectedLeftTableIds.length > 0
      )
        return; // 数组长度不大于0说明没有需要勾选的行数据
      if (flag == true) {
        // tabData重新赋值，都会触发重新渲染，所以要$nextTick等一个新的table
        this.$nextTick(() => {
          this.$refs.tableList.toggleRowSelection();
        });
      } else {
        this.$nextTick(() => {
          this.$refs.tableList.clearSelection();
        });
      }
    },

    // 批量删除
    batchDelete() {
      console.log(this.selectItemList);
      console.log(this.tableDataList);
      if (this.selectItemList.length == 0) {
        this.$message.warning('请选择商品');
        return;
      }
      this.tableDataList = productUtils.removeSameItem(
        this.tableDataList,
        this.selectItemList
      );
      let productTableList = JSON.parse(
        localStorage.getItem('productTableList')
      );
      productTableList = productUtils.removeSameItem(
        productTableList,
        this.selectItemList
      );
      localStorage.setItem(
        'productTableList',
        JSON.stringify(productTableList)
      );
      this.productTagPage.currentPage = 1;
      this.showTableDataList = this.tableDataList.slice(
        (this.productTagPage.currentPage - 1) * this.productTagPage.pageSize,
        this.productTagPage.currentPage * this.productTagPage.pageSize
      );
      this.selectItemList = [];
      console.log(this.selectItemList);
    },
    // 批量设置
    handleBatchSet(val) {
      console.log(val);
      // console.log( this.tableDataList);
      // console.log(this.selectItemList);
      const selectedArr = productUtils.getOneDimensionArr(this.selectItemList);
      productUtils.batchSetProduct(this.tableDataList, val, selectedArr);
      const productTableList = JSON.parse(
        localStorage.getItem('productTableList')
      );
      productUtils.batchSetProduct(productTableList, val, selectedArr);
      //  console.log( productTableList);
      localStorage.setItem(
        'productTableList',
        JSON.stringify(productTableList)
      );
      this.isShowSetDialog = false;
    },
    handleUnitSet(val) {
      console.log(val);
      const flag = util.isExistAttrInArr(
        this.unitListTable,
        'unitName',
        val.unitName
      );
      if (flag) {
        this.$message.warning('不能重复添加'); // 产品给的提示文案
        return;
      }
      this.unitListTable.push(val);

      this.tableDataList.map((item) => {
        item.unitVal.unitId = val.unitId;
        item.unitVal.unitValue = val.unitName;
      });
      const productTableList = JSON.parse(
        localStorage.getItem('productTableList')
      );
      productTableList.map((item) => {
        item.unitVal.unitId = val.unitId;
        item.unitVal.unitValue = val.unitName;
      });
      localStorage.setItem(
        'productTableList',
        JSON.stringify(productTableList)
      );
      this.isShowSetUnitDialog = false;
      console.log(this.tableDataList);
    },
    // 批量设置关闭取消
    handleBatchSetUpdate(val) {
      console.log(val);
      this.isShowSetDialog = false;
    },
    handleBatchSetUnitUpdate() {
      this.isShowSetUnitDialog = false;
    },
    // 申请规格弹框
    applyAttrDialog() {
      this.applyAttrVisible = !this.applyAttrVisible;
      this.getUnitInCategroy();
    },
    applyAttrUpdateVisible() {
      this.applyAttrVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    // 获取分类下的单位列表
    // async getUnitInCategroy() {
    //   let param = {
    //     categoryId: this.$store.state.productList.categoryId,
    //   };
    //   let res = await api.getUnitByCategory(param);
    //   console.log(res);
    //   if (res.code == 200) {
    //     this.unitList = res.data;
    //   }
    // },
    // 新增规格值
    addAttrValue() {
      if (this.attrStrValue == '') {
        this.$message.warning('规格值不能为空');
        return;
      }
      if (this.attrStrValue.length > 20) {
        this.$message.warning('最多可输入20个字');
        return;
      }
      if (this.attrForm.attrStr.indexOf(this.attrStrValue) != -1) {
        this.$message.warning('不可输入重复值');
        return;
      }
      this.attrForm.attrStr.push(this.attrStrValue);
      this.attrStrValue = '';
    },
    // 删除规格
    removeAttrStr(item) {
      const index = this.attrForm.attrStr.indexOf(item);
      if (index !== -1) {
        this.attrForm.attrStr.splice(index, 1);
      }
    },
    // 删除属性
    deleteAttr(row, val, idx, id) {
      // console.log(idx);
      console.log(
        util.getArgumentIndexInAttr(
          row.attributeValueListPage.records,
          'attributeValue',
          val
        )
      );
      const index = util.getArgumentIndexInAttr(
        row.attributeValueListPage.records,
        'attributeValue',
        val
      );
      row.attributeValueListPage.records.splice(index, 1);
      console.log(this.temSelectList);
      //  增加自定义规格删除时同步提交数据
      const selIndex = util.getArgumentIndexInAttr(
        this.temSelectList[idx],
        'attributeValue',
        val
      );
      this.temSelectList[idx].splice(selIndex, 1);
      this.showSelectAttrAndUnit(
        val,
        id,
        idx,
        'value',
        row.attributeName,
        row.attributeId
      );
    },
    //   添加属性
    addAttr(row, index) {
      console.log(this.attrValueList);
      // console.log(row);
      // console.log(util.deleteSpace(this.attrValueList[index].val));
      if (this.attrValueList[index].val == null) {
        this.$message.warning('规格值不能为空');
        return;
      }
      if (
        this.attrValueList[index].val == null ||
        this.attrValueList[index].val.length == 0
      ) {
        this.$message.warning('规格值不能为空');
        return;
      }
      if (
        util.getArgumentIndexInAttr(
          row.attributeValueListPage.records,
          'attributeValue',
          this.attrValueList[index].val
        ) == -1
      ) {
        if (util.deleteSpace(this.attrValueList[index].val).length > 20) {
          this.$message.warning('规格值不能超过20个字');
          return;
        }
        row.attributeValueListPage.records.push({
          attributeValue: this.attrValueList[index].val,
          checked: false,
        });
      } else {
        this.$message.warning('规格值不能重复');
      }

      this.attrValueList[index].val = null;
      console.log(this.formatTableData);
      // row.name.push(this.attrValue);
    },
    // 提交审核规格
    async attributeSubmitPopupData() {
      console.log(this.attrForm);
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          // let arr = [];
          // // this.attrForm.attrStr.map((item) => {
          // //   arr.push(item.value);
          // // });
          const params = {
            attributeAuditStatus: 1,
            attributeName: this.attrForm.attributeName,
            attributeUnit: this.attrForm.attributeUnit,
            categoryId: this.$store.state.productList.categoryId,
            categoryName: this.$store.state.productList.categoryName,
            attributeValueList: this.attrForm.attrStr,
          };

          const res = await api.createAttributeAudit(params);
          if (res.code == 200) {
            this.$message.success('申请成功');
            this.applyAttrVisible = false;
            this.$refs.ruleForm.resetFields();
          } else {
            this.$message.error(res.message);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    updateTableData(options) {
      // console.log(this.tableDataList);
      console.log(options);
      const table = this.tableDataList;
      // let tableIndex = options.tableIndex;
      const { tableId } = options;
      const { selStandardObj } = options;
      const { standardRadioObj } = options;
      const { unitRadioObj } = options;
      const beforeSymbol =
        standardRadioObj.beforeSymbol != undefined
          ? standardRadioObj.beforeSymbol
          : '';
      const behindSymbol =
        standardRadioObj.behindSymbol != undefined
          ? standardRadioObj.behindSymbol
          : '';
      const connectSymbol =
        standardRadioObj.connectSymbol != undefined
          ? standardRadioObj.connectSymbol
          : '';
      const unitName =
        unitRadioObj.unitName != undefined ? unitRadioObj.unitName : '';
      for (let i = 0; i < table.length; i++) {
        if (table[i].id == tableId) {
          console.log(123);
          // this.tableDataList[0]['公称直径'].val = standardRadioObj.attributeValue + unitRadioObj.unitName;
          this.tableDataList[i][selStandardObj.attributeName].val =
            standardRadioObj.attributeValue + unitName;
          this.tableDataList[i][selStandardObj.attributeName].attributeValue =
            standardRadioObj.attributeValue;
          this.tableDataList[i][selStandardObj.attributeName].attributeValueId =
            standardRadioObj.attributeValueId
              ? standardRadioObj.attributeValueId
              : '';
          this.tableDataList[i][selStandardObj.attributeName].unitId =
            unitRadioObj.unitId;
          this.tableDataList[i][selStandardObj.attributeName].unitValue =
            unitName;
          this.tableDataList[i][selStandardObj.attributeName].beforeSymbol =
            beforeSymbol;
          this.tableDataList[i][selStandardObj.attributeName].behindSymbol =
            behindSymbol;
          this.tableDataList[i][selStandardObj.attributeName].connectSymbol =
            connectSymbol;

          const skuName =
            beforeSymbol +
            (standardRadioObj.attributeValue + unitName) +
            behindSymbol +
            connectSymbol;
          if (this.tableDataList[i].skuName.indexOf(skuName) == -1) {
            this.tableDataList[i].skuName += ` ${beforeSymbol}${
              standardRadioObj.attributeValue + unitName
            }${behindSymbol}${connectSymbol}`;
          }
          // 修改本地数据
          const productTableList = JSON.parse(
            localStorage.getItem('productTableList')
          );

          productTableList[i][selStandardObj.attributeName].val =
            standardRadioObj.attributeValue + unitName;
          productTableList[i][selStandardObj.attributeName].attributeValue =
            standardRadioObj.attributeValue;
          productTableList[i][selStandardObj.attributeName].attributeValueId =
            standardRadioObj.attributeValueId
              ? standardRadioObj.attributeValueId
              : '';
          productTableList[i][selStandardObj.attributeName].unitId =
            unitRadioObj.unitId;
          productTableList[i][selStandardObj.attributeName].unitValue =
            unitName;
          productTableList[i][selStandardObj.attributeName].beforeSymbol =
            beforeSymbol;
          productTableList[i][selStandardObj.attributeName].behindSymbol =
            behindSymbol;
          productTableList[i][selStandardObj.attributeName].connectSymbol =
            connectSymbol;

          if (productTableList[i].skuName.indexOf(skuName) == -1) {
            productTableList[i].skuName += ` ${beforeSymbol}${
              standardRadioObj.attributeValue + unitName
            }${behindSymbol}${connectSymbol}`;
          }
          localStorage.setItem(
            'productTableList',
            JSON.stringify(productTableList)
          );
        }
        console.log(this.tableDataList);
      }
      this.standardRadioObj = {};
      // console.log(this.tableDataList);
    },
    // handleEvent() {},
    // 统一配图
    openAddImgDialog() {
      this.mainImgList = [];
      this.detailImgList = [];
      if (this.selectItemList.length <= 0) {
        this.$message.warning('请选择商品');
        return;
      }
      this.isMultImg = true;
      this.addImageDialogVisible = true;
      this.$refs.productAddImge.batchAddImg();
      // this.$refs.productAddImge.initData('batch');
      // this.addImageDialogVisible = true;
    },
    // 批量设置
    openSetDialog() {
      if (this.selectItemList.length <= 0) {
        this.$message.warning('请选择商品');
        return;
      }
      this.isShowSetDialog = true;
    },
    handleTab(type) {
      if (type === 1) {
        this.isShowList = true;
      } else {
        this.isShowList = false;
        this.sameAttrTableData = [];
        // let id = localStorage.getItem('isExistProductGroupProductId')
        // this.productTagPageSame.productId = id
        this.productTagPageSame.brandId = this.productInfo.brandId
          ? this.productInfo.brandId
          : null;
        this.productTagPageSame.attributeStr = this.productInfo.attributeStr;
        this.productTagPageSame.categoryId = this.productInfo.categoryId;
        // if (id != 'null') {
        this.getSameAttrSkusByProducId(this.productTagPageSame);
        // }
      }
    },
    async openDialog() {
      // this.unitVisible = true;
      // this.isShowTable = true;
      // this.repeatList = [];
      // this.imgRepeatList = [];
      // this.getAttrByPage(30);
      this.currentAttributeIndex = 0;
      this.temSelectList = []; // 暂存选中规格
      // this.unitList = [];
      this.checkList = [];
      this.unitCheckList = [];
      this.showSelectAttrAndUnitList = [];
      const res = await api.getPropertyByCategoryByPage({
        categoryId: this.$store.state.productList.categoryId,
        attributeType: 2,
        pageNum: 0,
        pageSize: 30,
        attributeId: '',
      });
      if (res.code === '200') {
        this.formatTableData = res.data;
        this.attributeId = this.formatTableData[0].attributeId;
        for (let i = 0; i < res.data.length; i++) {
          this.temSelectList.push([]);
          const attrObj = res.data[i];
          this.$set(attrObj, 'selectedAttributeValueList', []);
          this.$set(attrObj, 'selectedUnitList', []);
          this.showSelectAttrAndUnitList.push(attrObj);
          this.attrValueList.push({ val: null });
          this.unitCheckList.push([]);
          this.checkList.push([]);
        }
        this.drawerVisible = true;
      } else {
        this.$message.error(res.message);
      }
    },
    goPre() {
      Bus.$emit('changeStep', 1);
      // this.$router.go(-1); //返回上一层
    },
    // 获取相同属性商品
    async getSameAttrSkusByProducId(params) {
      const res = await api.getSameAttrSkusByProducId(params);
      if (res.code == 200) {
        console.log(res);
        this.sameAttrTableData = res.data;
      }
    },
    // 单个新增
    addOneProduct() {
      //  this.tableHeadList =  this.assemblyTableHead(this.formatTableData);
      if (!this.canAdd) return;
      this.repeatList = [];
      this.imgRepeatList = [];
      for (const key in this.tableHeadList) {
        // console.log(typeof this.tableHeadList[key].value);
        if (
          typeof this.tableHeadList[key].value !== 'undefined' && //修改sonar问题undefined改为字符串
          util.isObject(this.tableHeadList[key].value)
        ) {
          this.tableHeadList[key].value.attributeValue = '';
          this.tableHeadList[key].value.attributeValueId = '';
          this.tableHeadList[key].value.unitId = '';
          this.tableHeadList[key].value.unitValue = '';
          this.tableHeadList[key].value.val = '';
        }
      }
      // console.log(this.tableHeadList);
      this.assemblyTableData(this.tableHeadList);
      // Bus.$emit('getTableData', this.tableDataList);
    },

    // 组装单条数据的规格字符串
    assemblyOneDataStandardStr(obj) {
      const str =
        obj.beforeSymbol +
        // obj.attributeName +
        obj.attributeValue +
        obj.unitValue +
        obj.behindSymbol +
        obj.connectSymbol;
      return str;
    },
    // 组装单条新增数据
    assemblyOneSubmitData(arr) {
      const temArr = [];
      for (let i = 0; i < arr.length; i++) {
        const temObj = {};
        temObj.deliveryType =
          arr[i].deliveryType != '' ? Number(arr[i].deliveryType) : '';
        temObj.deliverTime =
          arr[i].deliverTime != '' ? Number(arr[i].deliverTime) : '';
        temObj.detailImageUrls = arr[i].detailImageUrls
          ? arr[i].detailImageUrls
          : [];
        temObj.imageUrls = arr[i].imageUrls ? arr[i].imageUrls : [];
        temObj.imageUrlsExist = arr[i].imageUrlsExist
          ? arr[i].imageUrlsExist
          : [];
        temObj.detailImageUrlsExist = arr[i].detailImageUrlsExist
          ? arr[i].detailImageUrlsExist
          : [];
        temObj.defaultImage =
          arr[i].mainImgList.length > 0 ? arr[i].mainImgList[0].url : '';
        temObj.isConfirm = arr[i].isConfirm;
        //  temObj.isConfirm = 1;//产品要求默认为1
        temObj.minOrderQuantity =
          arr[i].minOrderQuantity != '' ? Number(arr[i].minOrderQuantity) : '';
        temObj.price = arr[i].price != '' ? Number(arr[i].price) : '';
        temObj.skuName = arr[i].skuName
          .replace(/^\s\s*/, '')
          .replace(/\s\s*$/, '');
        temObj.skuStock = arr[i].skuStock != '' ? Number(arr[i].skuStock) : '';
        if (arr[i].unitVal.unitId) temObj.unitId = arr[i].unitVal.unitId;
        temObj.unitValue = arr[i].unitVal.unitValue;
        temObj.attributes = [];
        temObj.specificationStr = '';
        temObj.id = arr[i].id;
        for (const key in arr[i]) {
          if (util.isObject(arr[i])) {
            if (arr[i][key].isStandard == true) {
              temObj.attributes.push(arr[i][key]);
              temObj.specificationStr += this.assemblyOneDataStandardStr(
                arr[i][key]
              );
            }
          }
        }
        // temObj.specificationStr.slice(4);
        temArr.push(temObj);
      }
      return temArr;
    },

    handleChangeSkuName(num, name, id) {
      this.setAttrValueInLocal(id, name, num);
    },
    // 修改对应id的表数据
    changeNumById(arr, id, name) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id == id) {
          arr[i][name] = '';
        }
      }
      return arr;
    },
    // 验证0-100万正数不超过3位小数
    checkNumOneMillion(num, name, id) {
      const pattern =
        /^((0\.\d{1,3})|([1-9][0-9]{0,5}\.\d{1,3})|([1-9][0-9]{0,5})|0|1000000)$/;
      // console.log(pattern.test(num));
      if (!pattern.test(num)) {
        this.$message.warning('请输入0-100万之间的正数，最多3位小数');
        // this.tableDataList[index][name] = '';
        this.tableDataList = this.changeNumById(this.tableDataList, id, name);
        this.setAttrValueInLocal(id, name, '');
      } else {
        this.setAttrValueInLocal(id, name, num);
      }
      if (num == 0) {
        //  this.tableDataList[index][name] = '';
        this.tableDataList = this.changeNumById(this.tableDataList, id, name);
        this.setAttrValueInLocal(id, name, '');
      }
      // console.log(this.tableDataList);
    },
    // 验证0-10亿正数不超过3位小数
    checkNumOnebillion(num, name, id) {
      const pattern =
        /^((0\.\d{1,2})|([1-9][0-9]{0,9}\.\d{1,2})|([1-9][0-9]{0,9})|0|10000000000)$/;
      // console.log(pattern.test(num));
      if (!pattern.test(num)) {
        this.$message.warning('请输入0-10亿之间的正数，最多2位小数');
        // this.tableDataList[index][name] = '';
        this.tableDataList = this.changeNumById(this.tableDataList, id, name);
        this.setAttrValueInLocal(id, name, '');
      } else {
        this.setAttrValueInLocal(id, name, num);
      }
      // if (num == 0) {
      //   this.tableDataList = this.changeNumById(this.tableDataList, id, name);
      //   this.setAttrValueInLocal(id, name, "");
      // }
      // console.log(this.tableDataList);
    },
    // 验证0-100正数不超过3位小数
    checkNumOneHundred(num, name, id) {
      // var pattern = /^((0\.\d{1,3})|([1-9][0-9]{0,5}\.\d{1,3})|([1-9][0-9]{0,2})|0|100)$/;
      // var pattern = /^(?:0|[1-9][0-9]?|100)$/;
      const pattern =
        /^([1-9]|[1-9][0-9]|[1-2][0-9][0-9]|[3][0-5][0-9]|(360|361|363|362|364|365))$/;
      // console.log(pattern.test(num));
      if (!pattern.test(num)) {
        this.$message.warning('请输入0-365之间的正整数');
        // this.tableDataList[index][name] = '';
        this.tableDataList = this.changeNumById(this.tableDataList, id, name);
        this.setAttrValueInLocal(id, name, '');
      } else {
        this.setAttrValueInLocal(id, name, num);
      }
      if (num == 0) {
        //  this.tableDataList[index][name] = '';
        this.tableDataList = this.changeNumById(this.tableDataList, id, name);
        this.setAttrValueInLocal(id, name, '');
      }
      // console.log(this.tableDataList);
    },

    // 公共设置本地存储方法
    setAttrValueInLocal(id, attr, val) {
      const productTableList = JSON.parse(
        localStorage.getItem('productTableList')
      );
      for (let i = 0; i < productTableList.length; i++) {
        if (productTableList[i].id == id) {
          productTableList[i][attr] = val;
        }
      }
      localStorage.setItem(
        'productTableList',
        JSON.stringify(productTableList)
      );
      // console.log(productTableList);
    },

    // 提交商品发布
    async submitTable(type) {
      // this.handleReset();
      // console.log(this.tableDataList);
      if (this.tableDataList.length == 0) {
        this.$message.warning('您好，请先新增商品信息后，再提交审核或保存！');
        return;
      }
      const data = JSON.parse(JSON.stringify(this.$store.state.productList));
      data.taxRateValue = parseFloat(data.taxRateValue);
      const productTableList = JSON.parse(
        localStorage.getItem('productTableList')
      );
      console.log(productTableList);
      data.skus = this.assemblyOneSubmitData(productTableList);
      // data.skus = this.assemblyOneSubmitData(this.tableDataList);

      console.log(data);
      // if(type=="submit"){
      let isEmpty = false;
      let isEmptyImg = false;
      const repeatList = [];
      const imgRepeatList = [];
      for (let i = 0; i < data.skus.length; i++) {
        if (productUtils.isEmptyValInObject(data.skus[i])) {
          // 判断属性是否有空
          repeatList.push(data.skus[i].id);
          isEmpty = true;
        }
        if (productUtils.isEmptyImgInObject(data.skus[i])) {
          imgRepeatList.push(data.skus[i].id);
          // 判断图片是否都为空
          isEmptyImg = true;
        }
      }
      if (isEmpty) {
        this.repeatList = repeatList;
        this.$message.error('商品信息有空，请检查');
        //  this.repeatList = [];
        return;
      }
      if (isEmptyImg) {
        this.repeatList = imgRepeatList;
        this.$message.error('商品图有空，请检查');
        // this.repeatList = [];
        return;
      }
      // let flag = this.checkDuplicateSku(data.skus);
      if (data.skus.length > 1) {
        this.repeatList = this.checkDuplicateSku(data.skus);
        // debugger
        // console.log(this.repeatList);
        if (this.repeatList.length > 0) {
          this.$message.error('存在重复商品，请删除重复商品后在提交');
          // this.repeatList = [];
          return;
        }
      }

      // }
      // console.log(data);
      data.salesScope = Number(data.salesScope);
      // console.log(type);
      let res = null;
      if (type == 'submit') {
        res = await api.submitProduct(data);
      } else {
        res = await api.submitProductDrafts({ productAO: data });
      }

      if (res.code == 200) {
        localStorage.removeItem('productTableList');
        this.$message.success(
          type == 'submit'
            ? '提交成功，可在商品维护列表查看商品审核进度。'
            : '保存成功'
        );
        this.$router.push({ path: '/createProduct' });
        console.log(res);
      } else {
        // this.$message.error(res.message);
      }
    },
    // 判断是否重复
    checkDuplicateSku(array) {
      const repeatlist = [];
      // if (array.length <= 1) {
      //   return repeatlist;
      // }
      // let flag = false;
      for (let i = 0; i < array.length; i++) {
        for (let j = i + 1; j < array.length; j++) {
          if (
            array[i].specificationStr == array[j].specificationStr &&
            array[i].unitId == array[j].unitId
          ) {
            // flag = true;
            repeatlist.push(i);
            repeatlist.push(j);
            // break;
          }
        }
      }
      return repeatlist;
    },
    // 获取规格列表
    async getPropertyList(pageNum, attributeId) {
      // let res = await api.getPropertyByCategory({
      //   categoryId: this.$store.state.productList.categoryId,
      //   attributeType: 2
      // });
      const res = await api.getPropertyByCategoryByPage({
        categoryId: this.$store.state.productList.categoryId,
        attributeType: 2,
        pageNum,
        pageSize: 30,
        attributeId,
      });
      if (res.code == 200) {
        this.formatTableData = res.data;
        this.attributeId = this.formatTableData[0].attributeId;
        for (let i = 0; i < res.data.length; i++) {
          this.temSelectList.push([]);
          const attrObj = res.data[i];
          // attrObj.selectedAttributeValueList = [];
          // attrObj.selectedUnitList = [];
          this.$set(attrObj, 'selectedAttributeValueList', []);
          this.$set(attrObj, 'selectedUnitList', []);
          this.showSelectAttrAndUnitList.push(attrObj);
          this.attrValueList.push({ val: null });
          this.unitCheckList.push([]);
          this.checkList.push([]);
          this.filterInfo.fieldList.push({
            label: res.data[i].attributeName,
            type: 'input',
            value: res.data[i].attributeName,
          });
        }
        this.assemblyTableHead(res.data);
      } else {
        this.$message.error(res.message);
      }
      console.log(this.tableHeadList);
      console.log(this.tableDataList);
      // console.log(this.showSelectAttrAndUnitList);
    },
    // 组装表头数据
    assemblyTableHead(arr) {
      //  let productInfo = JSON.parse(JSON.stringify(this.$store.state.productInfo))
      // console.log(arr);
      for (let i = 0; i < arr.length; i++) {
        this.tableHeadList.splice(i + 1, 0, {
          align: 'center',
          label: arr[i].attributeName,
          param: arr[i].attributeName,
          slot: arr[i].attributeName,
          isProduct: true, // isProduct代表是新增商品
          value: {
            attributeId: arr[i].attributeId,
            attributeName: arr[i].attributeName,
            val: '',
            isStandard: true, // isStandard代表规格 为了组装商品提交数据
            attributeValue: '', // 规格属性值
            attributeValueId: '', // 规格属性值id
            unitId: '', // 计量单位id
            unitValue: '', // 计量单位值
            isBatch: false,
          },
        });
      }
      const { categoryList } = this.$store.state;

      // 组装规格属性
      for (let j = 0; j < categoryList.length; j++) {
        let val = '';
        let unit = '';
        const citem = categoryList[j].attributeValueList;
        const uitem = categoryList[j].unitList;
        let temStr = '';
        for (let k = 0; k < citem.length; k++) {
          if (citem[k].checked == true) {
            val = citem[k].attributeValue;
            temStr += citem[k].attributeValue; // 用于拼接商品名称
          }
        }
        for (let k = 0; k < uitem.length; k++) {
          if (uitem[k].checked == true) {
            unit = uitem[k].unitName;
            temStr += uitem[k].unitName; // 用于拼接商品名称
          }
        }
        const beforeSymbol =
          categoryList[j].beforeSymbol != undefined
            ? categoryList[j].beforeSymbol
            : '';
        const behindSymbol =
          categoryList[j].behindSymbol != undefined
            ? categoryList[j].behindSymbol
            : '';
        const connectSymbol =
          categoryList[j].connectSymbol != undefined
            ? categoryList[j].connectSymbol
            : '';
        this.attrStr += beforeSymbol + temStr + behindSymbol + connectSymbol;

        this.tableHeadList.splice(j + 1, 0, {
          align: 'center',
          label: categoryList[j].attributeName,
          param: categoryList[j].attributeName,
          //  slot:arr[i].attributeName,
          value: val + unit,
        });
      }
      this.canAdd = true;
      this.loading = false;
    },
    // 组装单条表数据
    assemblyTableData(arr) {
      // console.log(arr);
      const obj = {};
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].value) {
          obj[arr[i].param] = arr[i].value;
        } else {
          obj[arr[i].param] = '';
        }
        if (arr[i].param == 'skuName') {
          obj[arr[i].param] = `${
            this.$store.state.productList.brandNameEN +
            (this.$store.state.productList.brandNameEN != '' ? '/' : '') +
            this.$store.state.productList.brandName
          } ${this.$store.state.productList.categoryName} ${this.attrStr}`;
        }
        if (arr[i].param == 'unitVal') {
          obj[arr[i].param] = { unitId: '', unitValue: '' };
        }
        if (arr[i].param === 'deliverTime') {
          obj[arr[i].param] = '2';
        }
        if (arr[i].param === 'deliveryType') {
          obj[arr[i].param] = 1;
        }
      }
      //  this.tableDataList = JSON.parse(localStorage.getItem('productTableList'))
      this.tableDataList.push(JSON.parse(JSON.stringify(obj)));
      this.addOnlyIdForTableData(this.tableDataList);
      console.log(this.tableDataList);
      localStorage.setItem(
        'productTableList',
        JSON.stringify(this.tableDataList)
      );
      this.showTableDataList = this.tableDataList.slice(
        (this.productTagPage.currentPage - 1) * this.productTagPage.pageSize,
        this.productTagPage.currentPage * this.productTagPage.pageSize
      );
    },
    // 为新增数据增加id唯一值
    addOnlyIdForTableData(arr) {
      arr.map((item, index) => {
        item.id = index;
        item.detailImageUrls = item.detailImageUrls ? item.detailImageUrls : [];
        item.detailImageUrlsExist = item.detailImageUrlsExist
          ? item.detailImageUrlsExist
          : [];
        item.imageUrls = item.imageUrls ? item.imageUrls : [];
        item.imageUrlsExist = item.imageUrlsExist ? item.imageUrlsExist : [];
        // item.mainImgList = item.mainImgList ? item.mainImgList : [];
        this.$set(
          item,
          'mainImgList',
          item.mainImgList ? item.mainImgList : []
        );
      });
      return arr;
    },
    // 以下为批量新增
    // 保存规格
    async unitSubmitPopupData() {
      // console.log(this.temSelectList);
      // console.log(this.showSelectAttrAndUnitList);
      const { showSelectAttrAndUnitList } = this;
      for (let i = 0; i < showSelectAttrAndUnitList.length; i++) {
        this.temSelectList[i] = [];
        const ary = this.temSelectList[i];
        for (
          let j = 0;
          j < showSelectAttrAndUnitList[i].selectedAttributeValueList.length;
          j++
        ) {
          const itemVal =
            showSelectAttrAndUnitList[i].selectedAttributeValueList[j];

          // if (typeof itemVal.checked == 'undefined' || itemVal.checked == false)
          //   continue;
          if (showSelectAttrAndUnitList[i].selectedUnitList.length == 0) {
            const obj = {
              attributeValueId: itemVal.attributeValueId,
              attributeValue: itemVal.attributeValue,
              attributeName: itemVal.attributeName,
              attributeId: itemVal.attributeId,
              unitId: '',
              unitValue: '',
              isBatch: true,
              beforeSymbol: showSelectAttrAndUnitList[i].beforeSymbol,
              behindSymbol: showSelectAttrAndUnitList[i].behindSymbol,
              connectSymbol: showSelectAttrAndUnitList[i].connectSymbol,
              isStandard: true, // isStandard代表规格 为了组装商品提交数据
            };
            ary.push(obj);
          } else {
            for (
              let k = 0;
              k < showSelectAttrAndUnitList[i].selectedUnitList.length;
              k++
            ) {
              const unit = showSelectAttrAndUnitList[i].selectedUnitList[k];
              // if (typeof unit.checked == 'undefined' || unit.checked == false)
              //   continue;
              const obj = {
                attributeValueId: itemVal.attributeValueId,
                attributeValue: itemVal.attributeValue,
                attributeName: itemVal.attributeName,
                attributeId: itemVal.attributeId,
                unitId: unit.unitId,
                unitValue: unit.unitName,
                isBatch: true,
                beforeSymbol: showSelectAttrAndUnitList[i].beforeSymbol,
                behindSymbol: showSelectAttrAndUnitList[i].behindSymbol,
                connectSymbol: showSelectAttrAndUnitList[i].connectSymbol,
                isStandard: true, // isStandard代表规格 为了组装商品提交数据
              };
              ary.push(obj);
            }
          }

          // console.log(ary);
        }
      }
      console.log('finaly', this.temSelectList);
      if (productUtils.isEmptyAttr(this.temSelectList)) {
        this.$message.warning('请先选择取值与计量单位');
        return;
      }
      let arr = [];
      const deepArr = JSON.parse(JSON.stringify(this.temSelectList));
      arr = this.cartesianProductOfOtherLine(deepArr);
      // console.log(arr);
      // arr = this.assembleTableData(arr);
      this.assembleTableData(arr);
      // this.tableDataList = arr;
      this.tableDataList = this.addOnlyIdForTableData(this.tableDataList);
      localStorage.setItem(
        'productTableList',
        JSON.stringify(this.tableDataList)
      );
      this.showTableDataList = this.tableDataList.slice(
        (this.productTagPage.currentPage - 1) * this.productTagPage.pageSize,
        this.productTagPage.currentPage * this.productTagPage.pageSize
      );
      Bus.$emit('getTableData', this.tableDataList);
      this.unitVisible = false;
      this.drawerVisible = false;
      this.isShowTable = false;
      this.checkList = [];
      this.temSelectList = [];
      this.unitCheckList = [];
      // console.log(arr);
      const res = await api.getPropertyByCategory({
        categoryId: this.$store.state.productList.categoryId,
        attributeType: 2,
      });
      if (res.code == 200) {
        this.formatTableData = res.data;
        for (let i = 0; i < res.data.length; i++) {
          this.temSelectList.push([]);
          this.attrValueList.push({ val: null });
          this.unitCheckList.push([]);
          this.checkList.push([]);
        }
      }
      // this.tableData = res.data;}
    },

    // 组装批量新增商品表格数据
    assembleTableData(arr) {
      const formatData = this.tableHeadList;
      const resArr = [];
      //  let obj = {};
      arr.map((item) => {
        const obj = {};
        let specificationStr = '';
        for (const k in item) {
          // console.log(item[k]);
          const beforeSymbol =
            item[k].beforeSymbol != undefined ? item[k].beforeSymbol : '';
          const behindSymbol =
            item[k].behindSymbol != undefined ? item[k].behindSymbol : '';
          const connectSymbol =
            item[k].connectSymbol != undefined ? item[k].connectSymbol : '';
          specificationStr +=
            beforeSymbol +
            item[k].attributeValue +
            item[k].unitValue +
            behindSymbol +
            connectSymbol;
        }
        for (let i = 0; i < formatData.length; i++) {
          if (formatData[i].value) {
            //  obj[formatData[i].param] = item;
            if (formatData[i].value instanceof Object) {
              for (const key in item) {
                if (formatData[i].param == item[key].attributeName) {
                  obj[formatData[i].param] = item[key];
                }
              }
            } else {
              obj[formatData[i].param] = formatData[i].value;
            }
          } else {
            obj[formatData[i].param] = '';
          }
          if (formatData[i].param == 'skuName') {
            obj[formatData[i].param] = `${
              this.$store.state.productList.brandNameEN +
              (this.$store.state.productList.brandNameEN != '' ? '/' : '') +
              this.$store.state.productList.brandName
            } ${this.$store.state.productList.categoryName} ${
              this.attrStr
            }${specificationStr}`;
          }
          if (formatData[i].param == 'unitVal') {
            obj[formatData[i].param] = { unitId: '', unitValue: '' };
          }
          if (formatData[i].param === 'deliverTime') {
            obj[formatData[i].param] = '2';
          }
          if (formatData[i].param === 'deliveryType') {
            obj[formatData[i].param] = 1;
          }
        }
        // resArr.push(obj);
        this.tableDataList.push(obj);
      });
      // console.log(resArr);
      // return resArr;
    },
    // 选择规格值
    selectVale(
      val,
      id,
      index,
      name,
      standardName,
      standardId,
      beforeSymbol,
      behindSymbol,
      connectSymbol,
      type
    ) {
      // let temObj = { index: index, name: name, val: val };
      console.log(this.temSelectList);
      const valueList =
        this.formatTableData[index].attributeValueListPage.records;
      const { unitList } = this.formatTableData[index];
      if (name == 'value') {
        valueList.map((item) => {
          if (item.attributeValue == val) {
            if (item.checked) {
              item.checked = false;
            } else {
              item.checked = true;
            }
          }
        });
      } else {
        unitList.map((item) => {
          if (item.unitId == id) {
            if (item.checked) {
              item.checked = false;
            } else {
              item.checked = true;
            }
          }
        });
        // this.unitCheckList.push({index:id});
      }

      this.temSelectList[index] = [];
      const ary = this.temSelectList[index];
      for (let i = 0; i < valueList.length; i++) {
        const itemVal = valueList[i];

        if (typeof itemVal.checked === 'undefined' || itemVal.checked == false)
          continue;
        if (unitList.length == 0) {
          const obj = {
            attributeValueId: itemVal.attributeValueId,
            attributeValue: itemVal.attributeValue,
            attributeName: standardName,
            attributeId: standardId,
            unitId: '',
            unitValue: '',
            isBatch: true,
            beforeSymbol,
            behindSymbol,
            connectSymbol,
            isStandard: true, // isStandard代表规格 为了组装商品提交数据
          };
          ary.push(obj);
        } else {
          for (let j = 0; j < unitList.length; j++) {
            const unit = unitList[j];
            if (typeof unit.checked === 'undefined' || unit.checked == false)
              continue;
            const obj = {
              attributeValueId: itemVal.attributeValueId,
              attributeValue: itemVal.attributeValue,
              attributeName: standardName,
              attributeId: standardId,
              unitId: unit.unitId,
              unitValue: unit.unitName,
              isBatch: true,
              beforeSymbol,
              behindSymbol,
              connectSymbol,
              isStandard: true, // isStandard代表规格 为了组装商品提交数据
            };
            ary.push(obj);
          }
        }
      }
      if (type == undefined) {
        this.showSelectAttrAndUnit(
          val,
          id,
          index,
          name,
          standardName,
          standardId,
          beforeSymbol,
          behindSymbol,
          connectSymbol
        );
      }

      // console.log(this.unitCheckList);
      // console.log('checkList', this.checkList);

      // console.log('formatTableData', this.formatTableData);
      // console.log('temSelectList', this.temSelectList);
    },

    // 跨行规格拼接笛卡尔积
    cartesianProductOfOtherLine(list) {
      // parent上一级索引;count指针计数
      const point = {};
      const result = [];
      let pIndex = null;
      let tempCount = 0;
      let obj = {};
      // 根据参数列生成指针对象
      for (const index in list) {
        if (typeof list[index] === 'object') {
          point[index] = {
            parent: pIndex,
            count: 0,
          };
          pIndex = index;
        }
      }
      // 单维度数据结构直接返回
      if (pIndex === null) {
        return list;
      }
      // 动态生成笛卡尔积
      //  eslint-disable-next-line
      while (true) {
        let indexs = null;
        for (indexs in list) {
          tempCount = point[indexs].count;
          obj[indexs] = list[indexs][tempCount];
        }
        // 压入结果数组
        result.push(obj);
        obj = {};
        // 检查指针最大值问题
        //  eslint-disable-next-line
        while (true) {
          if (point[indexs].count + 1 >= list[indexs].length) {
            point[indexs].count = 0;
            pIndex = point[indexs].parent;
            if (pIndex === null) {
              return result;
            }
            // 赋值parent进行再次检查
            indexs = pIndex;
          } else {
            point[indexs].count++;
            break;
          }
        }
      }
    },

    // 选中规格名称
    handleChoiceAttribute(index, attributeId) {
      this.pageSize = 30;
      this.currentAttributeIndex = index;
      this.attributeId = attributeId;
      this.getAttrByPage(30, attributeId);
    },
    //  获取根据分页获取规格
    async getAttrByPage(pageSize, attributeId, attributeValue) {
      const res = await api.getPropertyByCategoryByPage({
        categoryId: this.$store.state.productList.categoryId,
        attributeType: 2,
        pageNum: 0,
        pageSize,
        attributeId,
        attributeValue: attributeValue || '',
      });
      if (res.code === '200') {
        this.formatTableData = res.data;
      }
    },

    // 展示已选项
    showSelectAttrAndUnit(
      val,
      id,
      index,
      name,
      standardName,
      standardId,
      beforeSymbol,
      behindSymbol,
      connectSymbol
    ) {
      if (name === 'value') {
        const flag = this.checkIsSelectAttrAndUnit(
          val,
          'attributeValue',
          this.showSelectAttrAndUnitList[index].selectedAttributeValueList
        );
        if (flag !== null) {
          this.showSelectAttrAndUnitList[
            index
          ].selectedAttributeValueList.splice(flag, 1);
        } else {
          this.showSelectAttrAndUnitList[index].selectedAttributeValueList.push(
            {
              attributeValue: val,
              attributeValueId: id,
              attributeName: standardName,
              attributeId: standardId,
            }
          );
        }
      }

      if (name === 'unit') {
        const flag = this.checkIsSelectAttrAndUnit(
          val,
          'unitName',
          this.showSelectAttrAndUnitList[index].selectedUnitList
        );
        if (flag !== null) {
          this.showSelectAttrAndUnitList[index].selectedUnitList.splice(
            flag,
            1
          );
        } else {
          this.showSelectAttrAndUnitList[index].selectedUnitList.push({
            unitName: val,
            unitId: id,
            attributeName: standardName,
            attributeId: standardId,
          });
        }
      }

      // console.log('=========', this.showSelectAttrAndUnitList);
    },
    // 判断是否是已选属性
    checkIsSelectAttrAndUnit(val, name, arr) {
      let flag = null;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i][name] === val) {
          flag = i;
          break;
        }
      }
      return flag;
    },
    // 加载更多
    async showMoreAttr(id, index) {
      this.pageSize += 30;
      await this.getAttrByPage(this.pageSize, id);
      await this.fillCheckedAttrAndUnit(index);
    },
    // 回显之前选中值
    fillCheckedAttrAndUnit(index) {
      // console.log(this.formatTableData);
      this.formatTableData.forEach((item, index) => {
        if (item.attributeValueListPage !== undefined) {
          // 回显规格值
          item.attributeValueListPage.records.forEach((subItem, subindex) => {
            this.showSelectAttrAndUnitList[
              index
            ].selectedAttributeValueList.forEach(
              (selecteditem, selectedindex) => {
                if (selecteditem.attributeValue === subItem.attributeValue) {
                  this.selectVale(
                    subItem.attributeValue,
                    subItem.attributeValueId,
                    index,
                    'value',
                    item.attributeName,
                    item.attributeId,
                    item.beforeSymbol,
                    item.behindSymbol,
                    item.connectSymbol,
                    'isShowMore'
                  );
                }
              }
            );
          });
          // 回显计量单位
          item.unitList.forEach((subItem, subindex) => {
            this.showSelectAttrAndUnitList[index].selectedUnitList.forEach(
              (selecteditem, selectedindex) => {
                if (selecteditem.unitName === subItem.unitName) {
                  this.selectVale(
                    subItem.unitName,
                    subItem.unitId,
                    index,
                    'unit',
                    item.attributeName,
                    item.attributeId,
                    item.beforeSymbol,
                    item.behindSymbol,
                    item.connectSymbol,
                    'isShowMore'
                  );
                }
              }
            );
          });
        }
      });
      // 回显自定义规格值
      this.showSelectAttrAndUnitList[index].selectedAttributeValueList.forEach(
        (item) => {
          if (item.attributeValueId === undefined) {
            this.formatTableData[index].attributeValueListPage.records.push(
              item
            );
            this.selectVale(
              item.attributeValue,
              item.attributeValueId,
              index,
              'value',
              item.attributeName,
              item.attributeId,
              this.showSelectAttrAndUnitList[index].beforeSymbol,
              this.showSelectAttrAndUnitList[index].behindSymbol,
              this.showSelectAttrAndUnitList[index].connectSymbol,
              'isShowMore'
            );
          }
        }
      );
    },
    //  规格值搜索
    async handleSearchAttrValue() {
      await this.getAttrByPage(30, this.attributeId, this.searchAttrValue);
      await this.fillCheckedAttrAndUnit();
    },
    handlechecked() {
      this.checked = !this.checked;
    },
    // 删除已选规格值或单位
    handleDelectAttrAndUnit(
      val,
      id,
      index,
      name,
      standardName,
      standardId,
      beforeSymbol,
      behindSymbol,
      connectSymbol
    ) {
      if (name === 'value') {
        const attrIndex = productUtils.getIndexInArr(
          this.showSelectAttrAndUnitList[index].selectedAttributeValueList,
          'attributeValue',
          val
        );
        this.showSelectAttrAndUnitList[index].selectedAttributeValueList.splice(
          attrIndex,
          1
        );
      }
      if (name === 'unit') {
        const attrIndex = productUtils.getIndexInArr(
          this.showSelectAttrAndUnitList[index].selectedUnitList,
          'unitName',
          val
        );
        this.showSelectAttrAndUnitList[index].selectedUnitList.splice(
          attrIndex,
          1
        );
      }
      if (this.currentAttributeIndex === index) {
        this.selectVale(
          val,
          id,
          index,
          name,
          standardName,
          standardId,
          beforeSymbol,
          behindSymbol,
          connectSymbol,
          '123'
        );
      }

      if (name === 'value') {
        const attrIndexs = this.getIndexInArr(this.checkList[index], val);
        this.checkList[index].splice(attrIndexs, 1);
      } else {
        const unitIndexs = this.getIndexInArr(this.unitCheckList[index], val);
        this.unitCheckList[index].splice(unitIndexs, 1);
      }
    },
    getIndexInArr(arr, val) {
      let index = -1;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] == val) {
          index = i;
          break;
        }
      }
      return index;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin/flex.scss';
@import '@/assets/css/theme.scss';
.container {
  .title {
    // border-bottom: 1px solid #ddd;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      &:first-child {
        font-size: 16px;
        color: #333;
      }
      &:last-child {
        font-size: 14px;
        color: #333;
        i {
          font-style: normal;
          color: #0064c8;
          cursor: pointer;
        }
      }
    }
  }
  .info-content {
    margin-top: 20px;
    .brand-box {
      @include flex(start, center, row);
    }
    .tab-content {
      display: flex;
      align-items: center;
      .tab-btn {
        width: 234px;
        display: inline-block;
        line-height: 40px;
        height: 40px;
        white-space: nowrap;
        cursor: pointer;
        background: #fff;
        // border: 1px solid #DCDFE6;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        transition: 0.1s;
        font-weight: 500;
        // padding: 12px 20px;
        font-size: 14px;
        // border-radius: 4px;
        border: 1px solid #ededed;
        position: relative;
        &.active {
          background: #f4f7ff;
          color: #0064c8;
          // border-top: 2px solid #0064c8;
          border-left: 1px solid #f4f7ff;
          border-right: 1px solid #f4f7ff;
          &::after {
            content: '';
            display: block;
            position: absolute;
            //  bottom: 0;
            left: 0;
            top: 0;
            width: 100%;
            height: 2px;
            background: #0064c8;
          }
        }
      }
    }
  }
  .rule-content {
    @include flex(start, center, row);
    margin-bottom: 18px;
  }
  .ope-content {
    text-align: center;
    margin-top: 20px;
  }
  .btn-content {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
}
.btn-box {
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  .btn-wrap {
    display: flex;
    align-items: center;
  }
}
.btn-save {
  // border: 1px solid #C5C5C5;
  color: #333333;
  font-size: 14px;
  width: 80px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  cursor: pointer;
  background: #ffe353;
}
.btn-default {
  border: 1px solid $main-col;
  color: $main-col;
  font-size: 14px;
  width: 80px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  cursor: pointer;
}
.attr-group {
  text-align: left;
  .el-checkbox {
    min-width: 100px;
    text-align: left;
  }
}
.icon-delete {
  width: 14px;
  height: 14px;
}

.page-wrap {
  margin-top: 20px;
  text-align: right;
}

.triangle-topleft {
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 30px solid #ef4c56;
  border-right: 30px solid transparent;
}
.img-in-table {
  width: 48px;
}
.attr-wrap {
  border: 1px solid #ddd;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  min-width: 30px;
  display: inline-block;
  margin-top: 1px;
  margin-right: 10px;
}
.img_dialog ::v-deep .el-dialog__header {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  background: #f5f5f5;
  padding: 8px;
  // /* padding-bottom: 10px;
}
.img_dialog ::v-deep .el-dialog__title {
  font-size: 14px;
  color: #333;
}
.img_dialog ::v-deep .el-dialog__headerbtn {
  top: 10px;
}
.img_dialog ::v-deep .el-dialog__body {
  padding: 10px 20px 10px 20px;
  max-height: 679px !important;
}
.next-btn {
  width: 120px;
  margin-left: 30px;
}
.el-button {
  font-size: 14px;
}
.info-form {
  background: #f5f5f5;
  margin: 10px auto;
  padding: 10px 0 10px 0;
}

.attr-input ::v-deep .el-input__inner {
  border-left: 0 !important;
  border-right: 0 !important;
  border-top: 0 !important;
  line-height: 30px;
  height: 30px;
}
.attr-txt {
  height: 40px;
  border-left: 1px solid #ededed;
  line-height: 40px;
  padding-left: 10px;
}
::v-deep .el-checkbox__label {
  white-space: normal;
  word-break: break-all;
}
::v-deep .el-radio {
  white-space: normal;
  word-break: break-all;
}
.table-head-wrap {
  display: flex;
  flex-flow: row;
  font-size: 14px;
  color: #333;
  font-weight: 500;
  background: #f5f5f5;

  .table-head-1 {
    width: 20%;
    border: 1px solid #dcdcdc;
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 10px;
  }
  .table-head-2 {
    width: 60%;
    height: 40px;
    display: flex;
    align-items: center;
    border-top: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 10px;
    padding-right: 10px;
  }
}
.table-body-wrap {
  display: flex;
  flex-flow: row;
  // border-left: 1px solid #dcdcdc;
  // border-bottom: 1px solid #dcdcdc;
  // border-right: 1px solid #dcdcdc;
  .table-body-1 {
    // width: 140px;
    // border-left: 1px solid #dcdcdc;
    &.attribute-name {
      height: 22px;
      cursor: pointer;
      font-size: 14px;
      color: #333;
      display: flex;
      align-items: center;
      padding: 4px;
      margin-bottom: 8px;
    }
    &.isActive {
      background: #e8f3ff;
      padding: 4px;
    }
  }
  .table-body-2 {
    // width: 500px;
  }
  .table-body-left,
  .table-body-center,
  .table-body-right {
    height: 400px;
    padding: 10px;
  }
  .table-body-left,
  .table-body-right {
    width: 20%;
    border-left: 1px solid #dcdcdc;
    border-right: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
  }

  .table-body-center {
    width: 60%;
    border-bottom: 1px solid #dcdcdc;
    overflow: auto;
  }
  .add-attr-btn-wrap {
    display: inline-block;
    text-align: center;
  }
}
.select-title {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin-top: 20px;
  margin-bottom: 10px;
}
.select-attr-wrap {
  overflow: auto;
  height: 300px;
  .table-row {
    display: flex;
    flex-flow: row;
    min-height: 62px;
    &:nth-child(odd) {
      background: #f8f8f8;
    }
    .table-col-1 {
      width: 80%;
      padding: 10px;
      border-top: 1px solid #dcdcdc;
      border-left: 1px solid #dcdcdc;
    }
    .table-col-2 {
      width: 20%;
      padding: 10px;
      border-top: 1px solid #dcdcdc;
      border-left: 1px solid #dcdcdc;
      border-right: 1px solid #dcdcdc;
    }
    .value-title {
      font-size: 12px;
      color: #333;
      line-height: 1;
    }
    .value-wrap {
      display: flex;
      flex-flow: wrap;
      margin-top: 10px;
      .value-item {
        border: 1px solid #d9d9d9;
        font-size: 12px;
        color: #666;
        padding: 4px 8px;
        background: #fff;
        margin-right: 10px;
        line-height: 1;
        flex-shrink: 0;
        margin-bottom: 10px;
      }
    }
  }
}
.drawer-wrap {
  height: calc(100% - 30%);
  overflow: auto;
}
</style>
